// Planted defects (engine/CLAUDE.md: beside what they break), so a game's checks can prove they fail.

/** The meta layer's planted defects. All off by default. */
export const META_FAULTS = {
  /** A tutorial prompt never retires: `Tutorials.use` does nothing (the tutorial check must go red). */
  tutorialNeverRetires: false,
  /** Photo mode's free camera ignores its radius (the bounded-camera check must go red). */
  photoUnbounded: false,
};

/** A planted defect's name. */
export type MetaFaultName = keyof typeof META_FAULTS;
